import actions from './actions';

const initialState = {
    cotizaciones: [],
};

export default function cotizacionReducer(state = initialState, action) {
    switch (action.type) {
        case actions.GET_COTIZACIONES_SUCCESS:
            return {
                ...state,
                cotizaciones: action.payload,
            }
        case actions.CREATE_COTIZACION_SUCCESS:
            return {
                ...state,
                cotizaciones: [...state.cotizaciones, action.payload]
            }
        case actions.EDIT_COTIZACION_SUCCESS:
            return {
                ...state,
                cotizaciones: state.cotizaciones.map(cotizacion => cotizacion._id === action.payload._id ? action.payload : cotizacion)
            }
        case actions.DELETE_COTIZACION_SUCCESS:
            return {
                ...state,
                cotizaciones: state.cotizaciones.filter(cotizacion => cotizacion._id !== action.payload)
            }
        default:
            return state;
    }

}
